module.exports = __webpack_public_path__ + "static/img/img_map_04.82f8f6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dali/img_map_04.png
// module id = GA65
// module chunks = 15